import { CURSOR_OVER, INTERACTIONS } from '../constants/Constants';
import { BtnSesame } from './BtnSesame';
import { ToyboxRays } from './ToyboxRays';

const VO_MAP = {
  prompt: ['NFC_6.0_102'],
  open_empty: ['NFC_6.0_103'],
  open_some: 'NFC_6.0_104',
  playful_stretching: 'NFC_7.0_117',
  humalong: 'NFC_7.0_115',
  star_breathing: 'NFC_7.0_113',
  hover_vo: 'NFC_1.1_8',
};

export class ToyboxMenu extends Phaser.GameObjects.Container {
  constructor(scene, x, y, unlocked) {
    super(scene, x, y);

    scene.add.existing(this);

    this.rays = new ToyboxRays(scene, 0, -150);
    this.rays.alpha = 0;
    this.add(this.rays);

    this.front = scene.add.image(0, 0, 'toybox', 'toybox_front').setOrigin(0.5, 1);
    const back = scene.add
      .image(this.front.x, this.front.y - 30, 'toybox', 'toybox_back')
      .setOrigin(0.5, 1);
    this.toyboxButtons = [];
    this.unlockedNumber = unlocked.length;

    // if (unlocked?.length) {
    this.toyboxButtons = INTERACTIONS.map((interaction, i) => {
      const x = -90 + 95 * i;
      const y = this.front.y - this.front.height * 0.9;
      const toyUnlocked = unlocked.includes(interaction.id);
      const btn = scene.add.image(
        x,
        y,
        'toybox',
        `toybox_item_${interaction.id}${toyUnlocked ? '' : '_grey'}`
      );
      btn.defaultPosition = { x, y };
      btn.id = interaction.id;
      btn.unlocked = unlocked.includes(interaction.id);
      if (btn.unlocked) {
      }

      btn.on('pointerdown', () => {
        if (btn.unlocked) this.emit('select_toy', btn.id);
        else {
          console.log(VO_MAP.open_some);
          this.scene.game.vo.play(VO_MAP.open_some);
        }
      });
      btn.on('pointerover', () => {
        if (btn.unlocked) this.scene.game.vo.play(VO_MAP[interaction.id]);
      });

      return btn;
    });

    this.btnClose = new BtnSesame(scene, {
      ...this.scene.game.hud.getButtonConfig('btn_close'),
      y: this.front.y - 80,
    });
    this.btnClose.visible = false;
    this.btnClose.on('click', this.close, this);

    this.add([back, ...this.toyboxButtons, this.front, this.btnClose]);
    this.front.setInteractive({ cursor: CURSOR_OVER });

    this._state = 'closed';
  }

  get isOpen() {
    return this._state == 'open';
  }

  enable() {
    this.front.on('pointerdown', this.handleFrameSelect, this);
    this.front.on('pointerover', this.handlePointerOver, this);
    this.front.on('pointerout', this.handlePointerOut, this);
  }

  disable() {
    this.front.off('pointerdown', this.handleFrameSelect, this);
    this.front.off('pointerover', this.handlePointerOver, this);
    this.front.off('pointerout', this.handlePointerOut, this);
  }

  handlePointerOver() {
    if (this._state == 'open') return;
    this.scene.game.vo.play(VO_MAP.hover_vo, { priority: -1 });
    this.scene.tweens.add({
      targets: this,
      scale: 1.2,
      duration: 150,
    });
  }
  handlePointerOut() {
    if (this._state == 'open') return;
    this.scene.tweens.add({
      targets: this,
      scale: 1,
      duration: 150,
    });
  }

  handleFrameSelect() {
    if (this.unlockedNumber) {
      // this.toggleState();
      this.emit('click');
    } else this.scene.game.vo.play(VO_MAP.open_empty);
  }

  triggerPrompt() {
    this.scene.game.vo.play(VO_MAP.prompt, { onComplete: () => this.triggerOptionPrompt(0) });
    this.scene.tweens.add({
      targets: this,
      scale: 1.1,
      yoyo: true,
      repeat: 1,
      duration: 150,
    });
  }

  triggerOptionPrompt(option) {
    if (option < this.toyboxButtons.length) {
      const btn = this.toyboxButtons[option];
      this.scene.game.vo.play(VO_MAP[btn.id], {
        onComplete: () => this.triggerOptionPrompt(option + 1),
      });
      this.scene.tweens.add({
        targets: btn,
        scale: 1.1,
        yoyo: true,
        repeat: 1,
        duration: 150,
      });
    }
  }

  toggleState() {
    if (this._state == 'closed') this.open();
    else this.close();
  }

  open() {
    if (this._state == 'open') return;

    if (!this.scene.game.player.toyboxOpened) {
      this.scene.game.player.setToyboxOpened();
      this.scene.game.vo.play(VO_MAP.prompt);
    }

    this.scale = 1;

    this.front.off('pointerdown', this.handleFrameSelect, this);
    this._state = 'open';
    this.emit('open');

    if (this.unlockedNumber < 2) this.scene.game.vo.play(VO_MAP.open_some);

    this.scene.tweens.killTweensOf(this.rays);
    this.rays.spin(true);
    this.scene.tweens.add({
      targets: this.rays,
      alpha: 1,
      duration: 250,
    });

    this.toyboxButtons.forEach((btn, i) => {
      const x = -300 + 300 * i;
      const y = -450;
      if (btn.unlocked) btn.setFrame(`toybox_item_${btn.id}_open`);
      btn.setInteractive({ cursor: CURSOR_OVER });
      btn.on('pointerover', () => {
        this.scene.tweens.killTweensOf(btn);
        this.scene.tweens.add({
          targets: btn,
          scale: 1.2,
          duration: 100,
        });
      });
      btn.on('pointerout', () => {
        this.scene.tweens.killTweensOf(btn);
        this.scene.tweens.add({
          targets: btn,
          scale: 1,
          duration: 100,
        });
      });
      this.scene.tweens.add({
        targets: btn,
        x,
        y,
        duration: 150,
        onComplete: () => {
          if (i == 0) this.btnClose.visible = true;
        },
      });
    });
  }

  close() {
    if (this._state == 'closed') return;

    this.scene.tweens.add({
      targets: this.rays,
      alpha: 0,
      duration: 100,
      onComplete: () => this.rays.spin(false),
    });

    this.btnClose.visible = false;
    this.front.on('pointerdown', this.handleFrameSelect, this);
    this._state = 'closed';
    this.emit('close');
    this.toyboxButtons.forEach((btn, i) => {
      btn.setFrame(`toybox_item_${btn.id}${btn.unlocked ? '' : '_grey'}`);
      btn.removeInteractive();
      this.scene.tweens.add({
        targets: btn,
        x: btn.defaultPosition.x,
        y: btn.defaultPosition.y,
        duration: 150,
      });
    });
  }

  destroy() {
    if (this.timer) {
      this.timer.remove();
      this.timer = null;
    }
    super.destroy();
  }
}
